/** Sprite font from C3 (letterprize*.png) — digits 0–9 in 5×2 grid */
export const RE_SPRITE_FONT = '/demo/red-envelope/letterprize1.png'
export const RE_SPRITE_COLS = 5
export const RE_SPRITE_CELL_W = 70
export const RE_SPRITE_CELL_H = 70
export const RE_SPRITE_W = 350
export const RE_SPRITE_H = 140

export function envelopeClosed(index: number) {
  return `/demo/red-envelope/letter${index}-closed.png`
}

export function envelopeOpen(index: number) {
  return `/demo/red-envelope/letter${index}-open.png`
}

/** Rolling counter similar to C3 countTo() in main.js */
export function rollValueToTarget(
  target: number,
  onTick: (value: number) => void,
): Promise<void> {
  return new Promise((resolve) => {
    let current = 0
    let step = 1
    let intervalMs = 12

    if (target <= 100) {
      step = 1
      intervalMs = 10
    } else if (target <= 200) {
      step = 5
      intervalMs = 10
    } else {
      step = 10
      intervalMs = 5
    }

    onTick(0)
    const id = window.setInterval(() => {
      current = Math.min(current + step, target)
      onTick(current)
      if (current >= target) {
        window.clearInterval(id)
        onTick(target)
        resolve()
      }
    }, intervalMs)
  })
}

export function delay(ms: number) {
  return new Promise<void>((r) => {
    window.setTimeout(r, ms)
  })
}
